import React from "react";
import { WidgetTeamScheduleContentList } from "./WidgetTeamScheduleContentList";
import { graphql, useFragment } from "react-relay";
import { WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily$key } from "./__generated__/WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily.graphql";
import { WidgetTeamScheduleContentBaseProps } from "./WidgetTeamScheduleContentBaseProps";
import { useNowIndexes } from "./useNowIndexes";
import { AHSeparator, Box } from "arkh";
import { WidgetTeamScheduleContentSectionHeader } from "./WidgetTeamScheduleContentSectionHeader";

export function WidgetTeamScheduleContentDaily(
  props: WidgetTeamScheduleContentBaseProps & {
    content: WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily$key;
  }
) {
  const content = useFragment(
    graphql`
      fragment WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily on WidgetTeamScheduleContentDaily {
        dailyTeamSchedule {
          ...WidgetTeamScheduleContentList_teamSchedule
          ...WidgetTeamScheduleContentSectionHeader_teamSchedule
          events(includeInlineRoutines: true) {
            ...useNowIndexes_teamScheduleEventOccasion
          }
        }
      }
    `,
    props.content
  );

  const [nowIndexes, scrollIndex] = useNowIndexes({
    eventKey: content.dailyTeamSchedule?.events ?? [],
    now: props.now,
  });

  return (
    <Box style={{ flex: 1 }}>
      <WidgetTeamScheduleContentSectionHeader
        tint={props.tint}
        teamSchedule={content.dailyTeamSchedule}
      />

      <AHSeparator spaceTop="xsmall" />
      <WidgetTeamScheduleContentList
        tint={props.tint}
        isDarkTint={props.isDarkTint}
        size={props.size}
        teamSchedule={content.dailyTeamSchedule}
        now={props.now}
        nowIndexes={nowIndexes}
        scrollIndex={scrollIndex}
        teamId={props.teamId}
        onPressRoutineOccasion={props.onPressRoutineOccasion}
        mode={props.mode}
        interactive={props.interactive}
        idiom={props.idiom}
        onScroll={props.onScroll}
        isFocused={props.isFocused}
      />
    </Box>
  );
}
